import { render, staticRenderFns } from "./WalkDashboard.vue?vue&type=template&id=009bd4ad"
import script from "./WalkDashboard.vue?vue&type=script&lang=js"
export * from "./WalkDashboard.vue?vue&type=script&lang=js"
import style0 from "./WalkDashboard.vue?vue&type=style&index=0&id=009bd4ad&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports